export const imageUrls = [
  "https://storage.googleapis.com/baby-dragon/public/AccountingBookIcon/AccoutingBookIcon-v2-1.png",
  "https://storage.googleapis.com/baby-dragon/public/AccountingBookIcon/AccoutingBookIcon-v2-2.png",
  "https://storage.googleapis.com/baby-dragon/public/AccountingBookIcon/AccoutingBookIcon-v2-3.png",
  "https://storage.googleapis.com/baby-dragon/public/AccountingBookIcon/AccoutingBookIcon-v2-4.png",
  "https://storage.googleapis.com/baby-dragon/public/AccountingBookIcon/AccoutingBookIcon-v2-5.png",
  "https://storage.googleapis.com/baby-dragon/public/AccountingBookIcon/AccoutingBookIcon-v2-6.png",
  "https://storage.googleapis.com/baby-dragon/public/AccountingBookIcon/AccoutingBookIcon-v2-7.png",
]
export const userImageUrls = [
  "https://storage.googleapis.com/baby-dragon/public/user_icon/person_01.png",
  "https://storage.googleapis.com/baby-dragon/public/user_icon/person_02.png",
  "https://storage.googleapis.com/baby-dragon/public/user_icon/person_03.png",
  "https://storage.googleapis.com/baby-dragon/public/user_icon/person_04.png",
  "https://storage.googleapis.com/baby-dragon/public/user_icon/person_05.png",
]
